import styled from 'styled-components'

const SectionTitle = styled.h2`
	text-align: center;
	font-family: 'Brittany Signature';
	font-size: 2.5rem;
	line-height: 5.5rem;
	letter-spacing: 0.2rem;
	color: hsl(351, 34%, 70%);
	padding: 0;
	margin-bottom: 3rem;
`

export default SectionTitle
